import Emitter from './emitter';

export default class Engine extends Emitter {
    constructor(uri) {
        super();

        this.uri = uri;
        this.createWs();
        this.wsEvents();
    }
    createWs() {
        this.ws = new WebSocket(this.uri);
        this.ws.sendObj = obj => this.ws.send(JSON.stringify(obj));
        return this.ws;
    }
    wsEvents() {
        this.ws.onopen = event => {
            this.emitReserved('open', event);
        };
        this.ws.onmessage = event => {
            const { data } = event;

            if (!data) {
                this.emitReserved('message', event);
            }

            try {
                const json = JSON.parse(data);
                this.emitReserved('data', json);
            } catch (err) {
                this.emitReserved('error', err);
            }
        };
        this.ws.onclose = event => {
            this.emitReserved('close', event);
        };
        this.ws.onerror = err => {
            this.emitReserved('error', err);
        };
    }
    close(...args) {
        this.ws && this.ws.close(...args);
    }
    send(...args) {
        this.ws && this.ws.send(...args);
    }
}
